import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { api, auditApi } from '../api/client';
import { AppHeader } from '../components/AppHeader';
import { AuditDashboardContent } from '../components/AuditDashboardContent';

export function AuditDashboardPage() {
  const navigate = useNavigate();
  const meQuery = useQuery({ queryKey: ['me'], queryFn: api.me, retry: false });

  if (meQuery.isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-wc-gray">
        <p className="text-sm text-wc-muted">Loading…</p>
      </div>
    );
  }
  if (meQuery.isError || !meQuery.data) {
    window.location.assign('/?returnTo=' + encodeURIComponent('/portal/audit'));
    return null;
  }
  if (!meQuery.data.canViewAuditDashboard) {
    // The user is signed in but has no dashboard grant. Send them back to the
    // regular portal instead of leaving them on a 403 surface.
    navigate('/portal', { replace: true });
    return null;
  }

  const me = meQuery.data;

  return (
    <div className="flex min-h-screen flex-col bg-wc-gray">
      <AppHeader me={me} />
      <main className="mx-auto w-full max-w-7xl flex-1 px-6 py-8">
        <AuditDashboardContent
          scopeKey={`portal:${me.customer.id}`}
          activeCustomerSlug={me.customer.slug}
          getSummary={(from, to) => auditApi.summary(from, to)}
          getEvents={(filters) => auditApi.events(filters)}
          getEngagements={(filters) => auditApi.engagements(filters)}
        />
      </main>
    </div>
  );
}
